/* istanbul ignore file */
import type { FunctionComponent } from 'react';
import React from 'react';
import { getPathnameFromUrl } from '@noths/polaris-client-utils';
import type { GetServerSideProps } from 'next';

import { Seo } from 'src/components/atoms/Seo/Seo';
import { getFeatureFlagsWithMatchers } from 'src/featureFlags/getFeatureFlagsWithMatchers';
import { fetchGlobalContent } from 'src/services/contentstack/fetchGlobalContent';
import * as styles from 'src/styles/studentDiscount.styles';

const COPY =
  'Student life = skint, are we right? Good job we’re giving you 10% discount with UNiDAYS. Discover gifts for all ' +
  'the big and small moments – whether you’re celebrating a flatmate’s bday or the dissertation hand-in (yasss). ' +
  'Best bit? Everything on Not On The High Street is made or sourced by a small business.';

const StudentDiscountPage: FunctionComponent = () => (
  <>
    <Seo description={COPY} title="Notonthehighstreet student discount" />
    <div css={styles.wrapper}>
      <div css={styles.container} data-wide={true}>
        <section>
          <h1 css={styles.title}>Student Discount</h1>
          <p css={styles.copy}>{COPY}</p>
          <script
            dangerouslySetInnerHTML={{
              __html: `(function(){try{ var a=addEventListener,b=function(){};a&&a("touchstart",b);a&&a("touchmove",b); a&&a("touchend",b)}catch(e){}}());`,
            }}
            type="text/javascript"
          />
          <iframe
            scrolling="no"
            src="https://www.myunidays.com/partners/noths/embedded/online"
            style={{ width: '100%', height: '705px', border: 'none' }}
            title="unidays"
          ></iframe>
        </section>
      </div>
    </div>
  </>
);

export const getServerSideProps: GetServerSideProps = async (context) => {
  const { req } = context;
  const featureFlags = (req && getFeatureFlagsWithMatchers(req)) || {};
  const pathname = getPathnameFromUrl(req.url ?? '');
  const [siteChromeContent] = await fetchGlobalContent({
    featureFlags,
    urlPath: pathname,
  });

  return {
    props: {
      siteChromeContent,
    },
  };
};

export default StudentDiscountPage;
